import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import React, { useEffect, useRef, useState } from 'react';
import style from './index.module.less'
import { Copy, Delete, More } from '@icon-park/react';
import { Popover, Select, Input } from 'antd';
import { noteServer } from '@/common/notesServer';
import { getImagePathWithTheme, imgPathPerfix } from "@/utils";
import { IconDropdownSelected } from "@/Icon";
import { t } from "i18next";
import {KEY_LIBRARY_TYPE, MAX_Z_INDEX, MENU_SEPARATOR} from "@/Const";
import clipboard from "clipboardy";

const CodeBlock = ({
                       editor,
                       node,
                       updateAttributes,
                       extension,
                   }) => {
    const inputRef = useRef(null);
    const searchRef = useRef(null);

    const [isShowSelect, setIsShowSelect] = useState(false);
    const [showTopBar, setShowTopBar] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const dropdownRef = useRef(null);

    const mouseover = (event) => {
        if (node.attrs.from != 'EditorCardItem') {
            setShowTopBar(true)
        }

    }
    const mouseleave = (event) => {
        setShowTopBar(false)
    }
    useEffect(() => {
        if (isShowSelect && searchRef.current) {
            setTimeout(() => {
                setSearchValue('');
                dropdownRef.current.scrollTop = 0; // 让滚动条回到顶部
            }, 13);
            setTimeout(() => {
                searchRef.current.focus();
            }, 170);
        }
    }, [isShowSelect]);

    useEffect(() => {
        // setTimeout(() => {
        //     updateAttributes({ language: 'Auto' })
        // }, 100)
        const codeElement = inputRef.current
        if (codeElement) {
            codeElement.addEventListener('mouseover', mouseover);
            codeElement.addEventListener('mouseleave', mouseleave);
        }

        return () => {
            if (codeElement) {
                codeElement.removeEventListener('mouseover', mouseover);
                codeElement.removeEventListener('mouseleave', mouseleave);
            }
        }
    }, [])

    const arrayLanguage = () => {
        var arrayLangs: any = [];
        arrayLangs.push({
            id: 'auto',
            label: t("Auto"),
            value: 'null'
        })
        arrayLangs.push({
            id: MENU_SEPARATOR,
            label: MENU_SEPARATOR,
            vale: 'sep',
            key: 'sep0',
            type: 'divider'
        })
        extension.options.lowlight.listLanguages().map((lang, index) => {
            arrayLangs.push({
                id: lang,
                label: lang,
                value: lang
            })
        });
        arrayLangs.map(item => {
            item.label = capitalizeFirstLetter(item.label)
            return item
        })
        return arrayLangs;
    }

    function copy() {
        noteServer.openTip("success", "Copied to clipboard");

        const dom = inputRef.current?.querySelector('pre');
        const htmlBlob = new Blob([dom.outerHTML], {type: 'text/html'});
        const textBlob = new Blob([dom.textContent || ''], {type: 'text/plain'});

        const item = new ClipboardItem({
            'text/html': htmlBlob,
            'text/plain': textBlob
        });

        navigator.clipboard.write([item]);
    }

    function del() {
        // inputRef.current?.parentElement.remove();
        //
        // if (Global.g_currentCardEditor && Global.g_currentCardEditElement){
        //     Global.g_currentCardEditElement.customData.generationData.html = Global.g_currentCardEditor.view.dom.innerHTML;
        // }

        const selectNodeNP = editor.$doc.querySelectorAll(node.type.name, {id: node.attrs.id})[0];
        if (selectNodeNP) {
            editor.commands.deleteRange({from: selectNodeNP.from - 1, to: selectNodeNP.to - 1});
        }
    }

    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    const filteredLanguages = arrayLanguage().filter((p) =>
        p.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    // const handleKeyDown = (e) => {
    //     if (!isShowSelect) return;

    //     if (e.key === 'ArrowDown') {
    //         console.log('---arrowdown--');
    //       // 向下箭头，选中下一个选项
    //       setHighlightedIndex(prev => (prev + 1) % filteredLanguages.length);
    //     } else if (e.key === 'ArrowUp') {
    //         console.log('---arrowup--');
    //       // 向上箭头，选中上一个选项
    //       setHighlightedIndex(prev => (prev - 1 + filteredLanguages.length) % filteredLanguages.length);
    //     } else if (e.key === 'Enter') {
    //       // 回车，确认选中项
    //     //   const selected = filteredLanguages[highlightedIndex];
    //     //   setSelectedLanguage(selected);
    //     //   setIsShowSelect(false);
    //     //   setSearchValue(''); // 清空搜索框
    //     //   setHighlightedIndex(-1); // 重置高亮
    //     }
    //   };

    return (
        <NodeViewWrapper className={style.code} ref={inputRef} style={{display: node.attrs.ifhidden ? 'none' : 'block'}}
                         data-language={node.attrs.language} spellCheck={false}>
            <pre data-language={node.attrs.language} spellCheck={false}>
                <NodeViewContent as="code" spellCheck={false}/>
            </pre>
            <div className={style.toolbar} style={{visibility: showTopBar ? 'visible' : 'hidden'}}>
                <Select
                    suffixIcon={<img className='img-mini-small-10' src={getImagePathWithTheme('drop_down_select')}
                                     onClick={() => setIsShowSelect(!isShowSelect)}/>}
                    open={isShowSelect}
                    dropdownClassName={'shadow'}
                    onDropdownVisibleChange={(open) => {
                        setIsShowSelect(open);
                    }}
                    variant={'borderless'}
                    style={{width: 'auto'}}
                    dropdownStyle={{width: '230px', color: '#939393', zIndex: MAX_Z_INDEX}}
                    value={node.attrs.language}
                    onChange={(event) => {
                        setIsShowSelect(false);
                        updateAttributes({language: event.target.value})
                    }} options={arrayLanguage()} dropdownRender={(menu) => {
                    return (
                        <div
                            onWheel={(event) => {
                                event.stopPropagation();
                            }}
                            ref={dropdownRef}
                            onMouseEnter={() => setShowTopBar(true)}
                            onMouseLeave={() => setShowTopBar(false)}
                            style={{overflowX: 'hidden', maxHeight: '320px', overflowY: 'auto'}}>
                            <div style={{padding: '8px 8px 2px 8px', borderBottom: '1px solid var(--border-color)'}}>
                                <Input
                                    ref={searchRef}
                                    bordered={false}
                                    style={{
                                        paddingLeft: '4px',
                                    }}
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={(e) => setSearchValue(e.target.value)}
                                />
                            </div>
                            {
                                filteredLanguages.map((p, index) =>
                                    <>
                                        {/* {
                                        p.id == MENU_SEPARATOR &&
                                        <div key={p.id} className={'line'} style={{ margin: '4px 0' }}></div>
                                    } */}
                                        {
                                            p.id !== MENU_SEPARATOR &&
                                            <div key={p.value} className={'dropdown-item'} onClick={() => {
                                                setIsShowSelect(false);
                                                updateAttributes({language: p.value})
                                            }}>
                                                <span className={'span-single-line'} style={{
                                                    paddingLeft: '12px',
                                                    paddingRight: '12px'
                                                }}>{p.label}</span>
                                            </div>
                                        }
                                    </>
                                )
                            }
                        </div>
                    )
                }}>
                    {/*<option value="null">auto</option>*/}
                    {/*{extension.options.lowlight.listLanguages().map((lang, index) => (*/}
                    {/*    <option key={index} value={lang}>*/}
                    {/*        {lang}*/}
                    {/*    </option>*/}
                    {/*))}*/}
                </Select>
                <div className={style.right}>
                    {/*<Copy theme="outline" size="20" fill="#999" onClick={copy}/>*/}
                    {/*<svg className={'cursor-pointer'}*/}
                    {/*     style={{*/}
                    {/*         width: '12px',*/}
                    {/*         height: '12px',*/}
                    {/*         marginLeft: '16px',*/}
                    {/*         marginRight: '4px',*/}
                    {/*         cursor: 'pointer'*/}
                    {/*     }}*/}
                    {/*     onClick={copy} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"*/}
                    {/*     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"*/}
                    {/*     className="lucide lucide-copy-icon lucide-copy">*/}
                    {/*    <rect width="14" height="14" x="8" y="8" rx="2" ry="2"/>*/}
                    {/*    <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"/>*/}
                    {/*</svg>*/}
                    <img className={'cursor-pointer'}
                         style={{width: '12px', height: '12px', marginLeft: '16px', marginRight: '0px'}}
                         src={getImagePathWithTheme('copy_code.svg')} onClick={copy}/>


                    <Popover trigger={'click'} zIndex={MAX_Z_INDEX} placement={"bottom"} content={
                        <div className={style.inner} onClick={del}>
                            <img className={'cursor-pointer'}
                                 style={{width: '14px', height: '14px', marginLeft: '1px', marginRight: '8px'}}
                                 src={getImagePathWithTheme('item_delete')}/>
                            <span>{t('Delete')}</span>
                        </div>}
                    >
                        <img className={'cursor-pointer'}
                             style={{width: '12px', height: '12px', marginLeft: '16px', marginRight: '4px'}}
                             src={getImagePathWithTheme('more_horizontal')}/>
                    </Popover>
                </div>
            </div>
        </NodeViewWrapper>
    )
};

export default CodeBlock;
